import React, { useEffect, useState } from "react";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import Modal from "~/components-shared/Modal";
import { Alert, Avatar, Card, Grid, Icon, InputSelect, InputText, Spinner, Text } from "~/components-shared";
import InfiniteScroll from "react-infinite-scroll-component";
import api from "~/lib/api";
import { AccessTypeEnum } from "~/types/enums";
import styled from "styled-components";
import { useSelector } from "react-redux";
import authSelectors from "~/store/auth/selectors";
const scrollPaneStyle = {
  overflow: "initial",
  height: "initial"
};
const Sticky = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
`;
const TopicNoteShareModal = _ref => {
  let {
    topicId,
    footprintId,
    note,
    onClose
  } = _ref;
  const {
    t
  } = useTranslation();
  const user = useSelector(authSelectors.getUser);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const [searchQuery, setSearchQuery] = useState("");
  const [members, setMembers] = useState([]);
  const [pagination, setOffset] = useState(undefined);
  const accessibility = note?.memberAccessibility;
  const handleChange = (memberId, accessType) => {
    if (note?.id) {
      setError(undefined);
      setLoading(true);
      api.changeTopicFootprintNoteAccess(topicId, footprintId, note.id, {
        memberId,
        accessType
      }).catch(e => {
        setError(e.message);
      }).finally(() => {
        setLoading(false);
      });
    }
  };
  const loadMembers = () => {
    setError(undefined);
    setLoading(true);
    api.fetchMembers({
      offset: pagination?.before || undefined,
      size: 9,
      filter: {
        query: searchQuery,
        memberIds: [user?.id]
      }
    }).then(response => {
      setMembers(response.items);
      setOffset(response.pagination);
    }).catch(e => {
      setError(e.message);
    }).finally(() => {
      setLoading(false);
    });
  };
  useEffect(() => {
    loadMembers();
  }, [searchQuery]);
  const handleSearch = query => {
    setSearchQuery(query);
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("TopicNoteShareModal.shareNotes"),
    onClose: onClose,
    fullWidth: true,
    maxWidth: "500px",
    fullHeight: true
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(InfiniteScroll, {
    style: scrollPaneStyle,
    dataLength: members.length || 0,
    next: loadMembers,
    hasMore: !!pagination?.hasBefore,
    loader: /*#__PURE__*/React.createElement(Spinner, {
      s: {
        mt: 6
      },
      center: true
    })
  }, /*#__PURE__*/React.createElement(Sticky, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(InputText, {
    value: searchQuery,
    onChange: handleSearch,
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: loading ? "spinner" : "search",
      s: {
        mr: 2
      }
    }),
    placeholder: t("common.actions.search"),
    s: {
      mb: 6
    },
    clearButton: true
  })), members.map(member => /*#__PURE__*/React.createElement(Card, {
    key: member.id,
    s: {
      mx: -3,
      px: 3,
      py: 3
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    gap: 5,
    cols: 3,
    template: "3.6rem 1fr 140px",
    align: "center",
    key: member.id
  }, /*#__PURE__*/React.createElement(Avatar, {
    size: 12.5,
    user: member,
    style: {
      cursor: "pointer"
    }
  }), /*#__PURE__*/React.createElement(Grid.Cell, {
    key: member.id,
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    color: "textSecondary",
    display: "block",
    fontSize: 3,
    lineHeight: 3.5
  }, member.role.name), /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    display: "block",
    fontSize: 4
  }, member.firstName, " ", member.lastName), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    display: "block",
    lineHeight: 4
  }, member.email)), /*#__PURE__*/React.createElement(InputSelect, {
    value: accessibility?.find(_ref2 => {
      let {
        member: {
          id
        }
      } = _ref2;
      return id === member.id;
    })?.accessType || AccessTypeEnum.NO_ACCESS,
    onChange: value => handleChange(member.id, value),
    options: [{
      id: AccessTypeEnum.NO_ACCESS,
      value: "No access"
    }, {
      id: AccessTypeEnum.VIEW,
      value: "View"
    }, {
      id: AccessTypeEnum.EDIT,
      value: "Edit"
    }],
    fullWidth: true
  })))))), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: onClose,
    rounded: true
  }, t("common.actions.close"))));
};
export default TopicNoteShareModal;